import * as React from "react";
import { Navigate } from "react-router-dom";
import useLocation from "routing/useLocation";
const LegacySecurityEventsRedirect = ({ from, to }) => {
  const { pathname, search, hash } = useLocation();
  const targetPath = pathname.includes(from) ? pathname.replace(from, to) : to;
  return /* @__PURE__ */ React.createElement(Navigate, { replace: true, to: { pathname: targetPath, search, hash } });
};
export default LegacySecurityEventsRedirect;
